import FormSelect from './FormSelect'

export default FormSelect



// WEBPACK FOOTER //
// ./src/components/Form/Select/index.js